function removeLeadingNewline(s) {
    if (s[0] === '\n') {
        s = s.slice(1);
    }
    return s;
}

function removeLastWhitespaceLine(lines) {
    //while the last line only consists of whitespace characters; remove it
    while (/^\s*$/g.test(lines[lines.length - 1])) {
        lines.pop();
    }

    return lines;
}

/**
 *  Cleans leading whitespace from the start of a block of text, but does not destroy any tabbed whitespace.
 *  Useful for cleaning the leading whitespace returned from el.innerHTML
 */

exports['default'] = function (s) {
    var sWithoutLeadingNewline = removeLeadingNewline(s);

    var lines = sWithoutLeadingNewline.split('\n');
    lines = removeLastWhitespaceLine(lines);

    var canTrimSpaces = true;

    while (canTrimSpaces) {

        canTrimSpaces = lines.every(function lineStartsWithSpace(line) {
            return line.length > 0 && line[0] === ' ';
        });

        if (canTrimSpaces) {
            for (var i = 0; i < lines.length; i++) {
                lines[i] = lines[i].substring(1);
            }
        }
    }

    return lines.join('\n');
};

module.exports = exports['default'];